import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const disconnect: IMcAppType = {
  name: "disconnect_SAP",
  path: "/my-account/disconnect",
  description: "Request a disconnect for a fuel on a property",
  navFlow: NavFlow.FOCUS,
  title: "Disconnect",
  parent: Tab.MORE,
  conditions: {
    intent: "disconnect",
    customerType: CustomerType.sap,
  },
};

export const disconnect_KRAKEN: IMcAppType = {
  name: "disconnect_KRAKEN",
  path:
    "/my/feedback/\\?formCode=rx_disconnect_a_property&title=Disconnect%20a%20property",
  description: "Request a disconnect for a fuel on a property",
  navFlow: NavFlow.FOCUS,
  title: "Disconnect a property",
  parent: Tab.MORE,
  conditions: {
    intent: "disconnect",
    customerType: CustomerType.kraken,
  },
  ignorePathMapping: true,
};
